export default __webpack_public_path__ + "static/media/2384.eb5606d4.png";